module.exports = __webpack_public_path__ + "static/img/4-2.60b3db99.png";